import React, { useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col, Card, CardHeader, CardBody, ModalFooter } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getDetailGuide } from '../../../slices/thunks';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import { LoadLogoLogin } from '../../../Layouts/LoadLogo';
import useLogoLoader from '../../../Components/Hooks/useLogoLoaderHooks';
import OPrint from '../../../Components/General/Widgets/OPrint';

const GuideDetail = ({ info, isOpen, toggle }) => {
  const { logoSrc, isSettingsLoading } = useLogoLoader("login");

  const printInvoice = () => {
    const content = document.getElementById('invoice').innerHTML;
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write('<html><head><title>Imprimir Factura</title>');
    printWindow.document.write('<style>@media print {body { -webkit-print-color-adjust: exact; </style>');
    printWindow.document.write('</head><body >');
    printWindow.document.write(content);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };

  const dispatch = useDispatch();

  const selector = createSelector(
    state => state.Guides,
    result => ({
      data: result.itemGuideList,
      isLoading: result.isLoading,
      isSuccess: result.isSuccess,
      isError: result.isError,
    })
  );

  const { data, isLoading, isSuccess, isError } = useSelector(selector);

  useEffect(() => {
    dispatch(getDetailGuide(info._id));
  }, [dispatch, info._id]);

  const formatNumber = (number, totalItems) => {
    const totalDigits = totalItems.toString().length;
    return number.toString().padStart(totalDigits, '0');
  };

  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', options).split('/').join('-');
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}
      size='lg'
      className='border-0'
      modalClassName='modal fade zoomIn'
      backdrop={'static'}
      centered={true}>
        
      <ModalHeader toggle={toggle}></ModalHeader>
      <ModalBody className='mb-0 pb-0'>
        <Row className="justify-content-center">
          <Col xxl={12}>
            <Card id="demo">
              <Row>
                <Col lg={12}>
                  <CardHeader className="border-bottom-dashed p-4">
                    <table className="principal">
                      <tbody>
                        <tr>
                          <td className="td-logo">
                            <LoadLogoLogin
                              logoSrc={logoSrc}
                              isSettingsLoading={isSettingsLoading}
                              height={50}
                            />
                          </td>
                          <td className="titulo">Caleta Bay</td>
                          <td className="tabla-nro" rowSpan="3">
                            <table className="nro">
                              <tbody>
                                <tr>
                                  <td>
                                    <table className="caja" style={{ color: 'red' }}>
                                      <tbody>
                                        <tr><td>R.U.T.: 12.345.678-9</td></tr>
                                        <tr><td>GUÍA DE DESPACHO</td></tr>
                                        <tr><td>ELECTRONICA</td></tr>
                                        <tr><td>Nº: {info.folio || info.guide_number || '-'}</td></tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr><td>S.I.I.- PUERTO MONTT</td></tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="2" className="direccion">
                            <p><b>GIRO: REPRODUCCION Y CRIANZA DE PECES MARINOS, MAYORISTAS DE PRODUCTOS DEL MAR, VENTA AL POR MAYOR DE DESECHOS DE PECES</b></p>
                            <p><b>CASA MATRIZ:</b> DIRECCION Puerto Montt Chile - Fono +56 65 FONO - fax +56 65 FONO</p>
                            <p><b>SUCURSALES:</b> SUCURSAL1 - SUCURSAL2</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardHeader>
                </Col>
                <Col lg={12} className='text-card-print'>
                  <CardBody className="p-4 border-top border-top-dashed">
                    <Row className="g-3">
                      <div className="master">
                        <table>
                          <tbody>
                            <tr>
                              <td className="tx-descripcion">Señor(es):</td>
                              <td colSpan="3">{info.final_destination?.name}</td>
                              <td className="tx-descripcion">Fecha Emisión:</td>
                              <td className="nowrap">{formatDate(info.guide_date)}</td>
                            </tr>
                            <tr>
                              <td className="tx-descripcion">Dirección:</td>
                              <td colSpan="3">{info.final_destination?.address}</td>
                              <td className="tx-descripcion">Patente:</td>
                              <td className="nowrap">{info.transfer_patente?.patent}</td>
                            </tr>
                            <tr>
                              <td className="tx-descripcion">Comuna:</td>
                              <td>CmnaRecep</td>
                              <td className="tx-descripcion">Ciudad:</td>
                              <td>CiudadRecep</td>
                              <td className="tx-descripcion">R.U.T. Transp:</td>
                              <td className="nowrap">RUTTrans</td>
                            </tr>
                            <tr>
                              <td className="tx-descripcion">Fono:</td>
                              <td>FonoRecep</td>
                              <td className="tx-descripcion">R.U.T.:</td>
                              <td>RUTRecep</td>
                              <td className="tx-descripcion">&nbsp;</td>
                              <td className="tx-descripcion">&nbsp;</td>
                            </tr>
                            <tr>
                              <td className="tx-descripcion">Giro:</td>
                              <td colSpan="3">GiroRecep</td>
                              <td className="tx-descripcion">&nbsp;</td>
                              <td className="tx-descripcion">&nbsp;</td>
                            </tr>
                            <tr>
                              <td className="tx-descripcion">Tipo Traslado:</td>
                              <td colSpan="3">TipoTrasladoRecep</td>
                              <td><b>OBSERVACION: VALOR REFERENCIAL</b></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Row>
                  </CardBody>
                </Col>
                <Col lg={12} className='text-card-print'>
                  <div className="table-responsive">
                    <table className="table table-borderless text-center table-nowrap align-middle mb-0">
                      <thead>
                        <tr className="table-active">
                          <th scope="col">#</th>
                          <th scope="col">Detalle</th>
                          <th scope="col">Cantidad/UM</th>
                          <th scope="col">Kg</th>
                          <th scope="col">Precio</th>
                          <th scope="col" className="text-end">Parcial</th>
                        </tr>
                      </thead>
                      <tbody className="products-list">
                        {data.map((item, index) => (
                          <tr key={index}>
                            <td scope="row">{formatNumber(index + 1, data.length)}</td>
                            <td className="text-start">
                              <span className="fw-semibold">{item.name}</span>
                              <p className="text-muted mb-0">{item.category}</p>
                            </td>
                            <td>{item.amount} {item.unit_measurement}</td>
                            <td>{item.kilograms_total} Kg</td>
                            <td className="text-end">$1</td>
                            <td className="text-end">${item.kilograms_total}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="border-top border-top-dashed mt-2">
                    <table className="table table-borderless table-nowrap align-middle mb-0 ms-auto">
                      <tbody className="products-list-final">
                        <tr>
                          <td className="text-end">Sub Total</td>
                          <td className="text-end">{info.subtotal}</td>
                        </tr>
                        <tr>
                          <td className="text-end">IVA (19%)</td>
                          <td className="text-end">{info.iva}</td>
                        </tr>
                        <tr>
                          <td className="text-end">Total</td>
                          <td className="text-end">{info.total}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="border-top mt-2">
                    <table className="table table-borderless table-nowrap align-middle mb-0 ms-auto">
                      <tbody>
                        <tr>
                          <td className="auto-width">Observación: </td>
                          <td className="w-100">{info.observation}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="border-top mt-2 p-2">
                    <table className="table table-borderless table-nowrap align-middle mb-0 ms-auto">
                      <tbody>
                        <tr>
                          <td className="auto-width">Nombre</td>
                          <td className="border-bottom w-50"></td>
                          <td className="auto-width">Fecha</td>
                          <td className="border-bottom w-50"></td>
                        </tr>
                        <tr>
                          <td className="auto-width">Recinto</td>
                          <td className="border-bottom"></td>
                          <td className="auto-width">Rut</td>
                          <td className="border-bottom"></td>
                        </tr>
                        <tr>
                          <td className="auto-width">Firma</td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="border-top mt-2">
                    <p className='m-0 p-2'>
                      El acuse de recibo que se declara en este acto, de acuerdo a lo
                      dispuesto en la letra b) del artículo 4° y la letra c) del artículo 5°
                      de la ley 19.983, acredita la entrega de mercadería(s) o servicio(s)
                      prestado(s) ha(n) sido recibido(s) en total conformidad
                    </p>
                  </div>
                </Col>
              </Row>
            </Card>
            <OPrint referenceId={'demo'}></OPrint>
          </Col>
        </Row>
      </ModalBody>
      {/* <ModalFooter>
        <div className="hstack gap-2 justify-content-end d-print-none">
          <Link onClick={printInvoice} to="#" className="btn btn-success"><i className="icon-printer label-icon"></i> Print</Link>
          <Link to="#" className="btn btn-label btn-primary"><i className="icon-download label-icon"></i> Download</Link>
        </div>
      </ModalFooter> */}
    </Modal>
  );
};

export default GuideDetail;
